var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2541_438266)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#36A7F5",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2541_438266",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2541_438266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 13.4C14.2108 13.4 14.3859 13.3306 14.525 13.192C14.6637 13.0528 14.733 12.8777 14.733 12.6666V10.05C14.733 9.83884 14.6637 9.66662 14.525 9.53328C14.3859 9.39995 14.2108 9.33328 13.9997 9.33328C13.7886 9.33328 13.6137 9.40262 13.475 9.54128C13.3359 9.6804 13.2664 9.85551 13.2664 10.0666V12.6833C13.2664 12.8833 13.3359 13.0528 13.475 13.192C13.6137 13.3306 13.7886 13.4 13.9997 13.4ZM13.9997 8.08328C14.2108 8.08328 14.3886 8.01106 14.533 7.86662C14.6775 7.72217 14.7497 7.5444 14.7497 7.33328C14.7497 7.12217 14.6775 6.9444 14.533 6.79995C14.3886 6.65551 14.2108 6.58328 13.9997 6.58328C13.7886 6.58328 13.6108 6.65551 13.4664 6.79995C13.3219 6.9444 13.2497 7.12217 13.2497 7.33328C13.2497 7.5444 13.3219 7.72217 13.4664 7.86662C13.6108 8.01106 13.7886 8.08328 13.9997 8.08328ZM13.9997 16.8C13.0553 16.8 12.169 16.6222 11.341 16.2666C10.5135 15.9111 9.79415 15.4277 9.18304 14.8166C8.57193 14.2055 8.0886 13.4862 7.73304 12.6586C7.37748 11.8306 7.19971 10.9444 7.19971 9.99995C7.19971 9.05551 7.37748 8.16928 7.73304 7.34128C8.0886 6.51373 8.57193 5.7944 9.18304 5.18328C9.79415 4.57217 10.5135 4.08884 11.341 3.73328C12.169 3.37773 13.0553 3.19995 13.9997 3.19995C14.9442 3.19995 15.8304 3.37773 16.6584 3.73328C17.4859 4.08884 18.2053 4.57217 18.8164 5.18328C19.4275 5.7944 19.9108 6.51373 20.2664 7.34128C20.6219 8.16928 20.7997 9.05551 20.7997 9.99995C20.7997 10.9444 20.6219 11.8306 20.2664 12.6586C19.9108 13.4862 19.4275 14.2055 18.8164 14.8166C18.2053 15.4277 17.4859 15.9111 16.6584 16.2666C15.8304 16.6222 14.9442 16.8 13.9997 16.8ZM13.9997 15.2833C15.4664 15.2833 16.7137 14.7695 17.7417 13.742C18.7693 12.714 19.283 11.4666 19.283 9.99995C19.283 8.53328 18.7693 7.28595 17.7417 6.25795C16.7137 5.2304 15.4664 4.71662 13.9997 4.71662C12.533 4.71662 11.2859 5.2304 10.2584 6.25795C9.23037 7.28595 8.71637 8.53328 8.71637 9.99995C8.71637 11.4666 9.23037 12.714 10.2584 13.742C11.2859 14.7695 12.533 15.2833 13.9997 15.2833Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2541_438266",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.88 0 0 0 0 0.88 0 0 0 0 0.88 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2541_438266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2541_438266",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcons);
export default __webpack_public_path__ + "static/media/footerIcons.d3ef41891da47c729b02f6e4a02d4731.svg";
export { ForwardRef as ReactComponent };